import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () =>
      import('./features/registration/registration.component').then(m => m.RegistrationComponent),
  },
  {
    path: 'payer',
    loadComponent: () =>
      import('./features/payment-completion/payment-completion.component').then(m => m.PaymentCompletionComponent),
  },
  {
    path: 'paiement',
    loadComponent: () =>
      import('./features/payment-callback/payment-callback.component').then(m => m.PaymentCallbackComponent),
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./features/auth/login/login.component').then(m => m.LoginComponent),
  },
  {
    path: 'admin',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/admin/admin.component').then(m => m.AdminComponent),
  },
  { path: '**', redirectTo: '' },
];
